<nz-modal
  [nzWidth]="'800px'"
  [(nzVisible)]="isVisible"
  (nzVisibleChange)="onIsVisibleChange($event)"
  [nzTitle]="'Edit Objections'"
  [nzOkText]="null"
  [nzCancelText]="'Close'"
  (nzOnCancel)="onCancelClick()"
>
  <ng-container *nzModalContent>
    <nz-select
      nzShowSearch
      nzAllowClear
      nzPlaceHolder="Add Objection"
      [ngModel]="selectedObjectionId"
      (ngModelChange)="onSelectedObjectionIdChange($event)"
    >
      @if (isEmotionalObjection) {
        @for (item of emotionalObjectionList(); track $index) {
          <nz-option [nzLabel]="item.title ?? ''" [nzValue]="item.id"></nz-option>
        }
      } @else {
        @for (item of factObjectionList(); track $index) {
          <nz-option [nzLabel]="item.title ?? ''" [nzValue]="item.id"></nz-option>
        }
      }
    </nz-select>

    <nz-table
      #basicTable
      [nzData]="isEmotionalObjection ? emotionalObjectionSessionTemplateList() : factObjectionSessionTemplateList()"
    >
      <thead>
        <tr>
          <th>Question</th>
          <th>Answer</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        @for (data of basicTable.data; track data) {
          <tr>
            <td>{{ data.title }}</td>
            <td>{{ data.description }}</td>
            <td>
              <button nz-button nzType="default" nzSize="small" (click)="onDeleteClick(data)">
                <span nz-icon style="font-size: 16px" class="material-symbols-rounded">delete</span>
              </button>
            </td>
          </tr>
        }
      </tbody>
    </nz-table>
  </ng-container>
</nz-modal>
